import _ from "lodash";
import React from "react";
import { IFieldInstance } from "../../../types/fieldInstance.interface";
import { getFormGroups } from "../../../utils/formGenUtils/getFormGroups";
import { SectionFieldsContainer } from "./incidentForm.style";
import SectionFormFields from "./SectionFormFields";
import { useIncidentFormContext } from "./IncidentContext";
import { useFormikContext } from "formik";

export interface ITabSection {
  section: IFieldInstance[];
  isOpened: boolean;
  index?: number;
}

const TabSection = ({ section, isOpened, index }: ITabSection) => {
  const { viewModel, isSubmitting } = useIncidentFormContext();

  const formik = useFormikContext<{ [x: string]: any }>();
  function getError(
    fieldName: string,
    showOnChange: boolean = false
  ): string | null {
    let error = null;
    let _touched = false;
    if (
      formik.errors[fieldName] &&
      typeof formik.errors[fieldName] === "string"
    ) {
      error = formik.errors[fieldName];
      _touched = isSubmitting ? true : !!formik.touched[fieldName];
    } else {
      error = _.get(formik.errors, fieldName) ?? null;
      const touchedForObj = _.get(formik.touched, fieldName);
      _touched = !!touchedForObj;
    }
    if (error && typeof error === "string") {
      const shouldShowOnChange = showOnChange && !error.includes("required");
      let errorMessage;
      if (shouldShowOnChange) {
        errorMessage = error;
      }
      errorMessage = _touched ? error : null;
      return errorMessage as string;
    } else {
      return null;
    }
  }

  const sectionFormGroups = getFormGroups(section);

  function shouldGroupRender(formGroup: IFieldInstance[]) {
    return formGroup.length && viewModel[formGroup[0].id];
  }

  return (
    <>
      <SectionFieldsContainer
        isOpened={isOpened}
        index={index}
        className={`${isOpened ? "open" : ""}`}
      >
        {sectionFormGroups.map((formGroup: IFieldInstance[], index) => (
          <React.Fragment key={`${index}-${formGroup[0].fieldName}`}>
            {shouldGroupRender(formGroup) && (
              <SectionFormFields
                key={index}
                formGroup={formGroup}
                getError={getError}
              />
            )}
          </React.Fragment>
        ))}
      </SectionFieldsContainer>
    </>
  );
};

export default TabSection;
